<template>
  <div class="">
    <div class="flex justify-between items-start py-8 md:py-0">
      <ul class="md:py-12 sidelist px-2 md:px-8 md:mt-12" ref="sidelist">
        <li class="text-sm" @click="selected = 'introduction'">
          <a href="#introduction" :class="[selected == 'introduction' ? selectedClass : 'text-sm']">
            Introduction
          </a>
        </li>
        <li class="mt-6" @click="selected = 'links'">
          <a href="#links"  :class="[selected == 'links' ? selectedClass : 'text-sm']">
            Links to non-eTranzact websites
          </a>
        </li>
        <li class="mt-6" @click="selected = 'collect'">
          <a href="#collect" :class="[selected == 'collect' ? selectedClass : 'text-sm']">
            Collection of personal information
          </a> 
          </li>
        <li class="mt-6" @click="selected = 'how'">
          <a href="#how" :class="[selected == 'how' ? selectedClass : 'text-sm']">
            How we use the information
          </a>
          </li>
        <li class="mt-6" @click="selected = 'prevent'">
          <a href="#prevent" :class="[selected == 'prevent' ? selectedClass : 'text-sm']">
            How do we prevent harm to your personal Data? 
          </a>
          </li>
        <li class="mt-6" @click="selected = 'changes'">
          <a href="#changes" :class="[selected == 'changes' ? selectedClass : 'text-sm']">
            How will we notify you of changes to this policy?
          </a>
          </li>
        <li class="mt-6" @click="selected = 'protection'">
          <a href="#protection" :class="[selected == 'protection' ? selectedClass : 'text-sm']">
            Data Protection Rights
          </a>
          </li>
        <!-- <li class="mt-6" @click="selected = 'liability'">
          <a href="#liability" :class="[selected == 'liability' ? selectedClass : 'text-sm']">
            Availability of Service
          </a>
          </li>
        <li class="mt-6" @click="selected = 'exclusions'">
          <a href="#exclusions" :class="[selected == 'exclusions' ? selectedClass : 'text-sm']">
            Advertising of Packaged Services 
          </a>
          </li>
        <li class="mt-6" @click="selected = 'other'">
          <a href="#other" :class="[selected == 'other' ? selectedClass : 'text-sm']">
            Complaint Processes
          </a>
          </li>
        <li class="mt-6" @click="selected = 'modification'">
          <a href="#modification" :class="[selected == 'modification' ? selectedClass : 'text-sm']">
            Further Recourse  
          </a>
          </li>
        <li class="mt-6" @click="selected = 'user'">
          <a href="#user" :class="[selected == 'user' ? selectedClass : 'text-sm']">
            Data Collection and Analysis of Complaints and Outcome
          </a>
          </li>
        <li class="mt-6" @click="selected = 'third'">
          <a href="#third" :class="[selected == 'third' ? selectedClass : 'text-sm']">
            Retention of Records 
          </a>
          </li>
        <li class="mt-6" @click="selected = 'indem'">
          <a href="#indem" :class="[selected == 'indem' ? selectedClass : 'text-sm']">
            Opt-In and Opt-Out
          </a>
          </li>
        <li class="mt-6" @click="selected = 'eco'">
          <a href="#eco" :class="[selected == 'eco' ? selectedClass : 'text-sm']">
            Billing Information 
          </a>
          </li>
        <li class="mt-6" @click="selected = 'general'">
          <a href="#general" :class="[selected == 'general' ? selectedClass : 'text-sm']">
            Itemization of Charges
          </a>
          </li>
        <li class="mt-6" @click="selected = 'mod'">
          <a href="#mod" :class="[selected == 'mod' ? selectedClass : 'text-sm']">
            Timing for Issuance of Bill  
          </a>
          </li>
        <li class="mt-6" @click="selected = 'pcon'">
          <a href="#pcon" :class="[selected == 'pcon' ? selectedClass : 'text-sm']">
            Payment Confirmation 
          </a>
          </li>
        <li class="mt-6" @click="selected = 'freq'">
          <a href="#freq" :class="[selected == 'freq' ? selectedClass : 'text-sm']">
            Billing Frequency   
          </a>
          </li> -->
      </ul>
      <div class="details w-full md:py-12 md:mt-12">
        <p style="color: #062648" class="text-lg font-bold" id="introduction">Introduction</p>
        <p class="mt-6 text-gray-400 text-sm leading-7">
         eTranzact is  a Public Limited liability Company, with legal entities, business processes, management structures, and technical systems.  This policy describes the information we collect and process in compliance with the GDPR/NDPR and other international regulations in the course of onboarding and supporting our customers and strategic partners.
        </p>
        <p class="mt-6 text-gray-400 text-sm leading-7">
         The Privacy Policy applies to all of the services offered by eTranzact. It doesn’t however apply to services that have separate privacy policies that do not incorporate this Privacy Policy such as the information practices of other companies and organizations that integrate to our platform.
        </p>
        <ul>
          <li class="mt-8 pt-4" id="links">
            <p class="text-blue-500 text-sm font-bold">Links to non-eTranzact websites </p>
            <p class=" mt-6 text-gray-400 text-sm leading-7">The eTranzact website may provide links to third-party websites for your convenience and information.  If you access those links, you will leave eTranzact’s website. eTranzact does not control those sites or their privacy practices, which may differ from eTranzact’s practices. We do not endorse or make any representations about third-party websites. The personal data you choose to provide to or that is collected by these third parties is not covered by the eTranzact Privacy Statement. We encourage you to review the privacy policy of any company before submitting your personal information.

            </p>
          </li>
          <li class="mt-8 pt-4" id="collect">
            <p class="text-blue-500 text-sm font-bold">Collection of personal information</p>
            <p class=" mt-6 text-gray-400 text-sm leading-7">To serve you better by providing better services to all our users/customers and understand your needs and interests, eTranzact collects and processes information with adequate notice and consent, along with required filings with data protection authorities, when applicable.
            </p>
            <p class=" mt-6 text-gray-400 text-sm leading-7">eTranzact may also collect information during your visit our website through our Automatic Data Collection Tools, which include Web beacons, cookies, embedded Web links, and other commonly used information-gathering tools. These tools collect certain standard information that your browser sends to our website such as your browser type and language, access times, and the address of the website from which you arrived at an eTranzact website. We may also collect information about your Internet Protocol (IP) address, clickstream behavior (i.e. the pages you view, the links you click, and other actions you take in connection with eTranzact websites).
            </p>
          </li>
          <li class="mt-8 pt-4" id="how">
            <p class="text-blue-500 text-sm font-bold">How we use the information</p>
            <p class=" mt-6 text-gray-400 text-sm leading-7">The information eTranzact collects to understand your needs and interests helps us deliver a consistent and personalized experience. For example, eTranzact may use your information to assist you in completing a transaction; prevent and detect fraud or other malicious activity; communicate with you about products and services; provide service and support; update you on new services and benefits; provide personalized promotional offers; select content to be communicated to you. 
            </p>
          </li>
          <li class="mt-8 pt-4" id="services"> 
            <p class="text-blue-500 text-sm font-bold">Service Contracts and Duration </p>
            <p class=" mt-6 text-gray-400 text-sm leading-7">eTranzact shall supply, or make available on request, a copy of the contract or agreement for the provision of services, and such contracts shall be written in plain and clear language. Description of Services eTranzact offers USSD and Bulk SMS Services. This service caters to customer’s need for SMS broadcast in areas such as marketing campaigns, promotion activities, and customer notifications.</p>
            <p class=" mt-6 text-gray-400 text-sm leading-7">eTranzact will not share the personal information you provide to eTranzact with non- eTranzact third parties without your permission, unless to: </p>
            <ul class="mt-4">
              <li class="text-gray-400 text-sm mb-2">(i) Respond to duly authorized information requests of police and governmental authorities;</li>
              <li class="text-gray-400 text-sm mb-2">(ii) Comply with any law, regulation, subpoena, or court order;</li>
              <li class="text-gray-400 text-sm mb-2">(iii) Help prevent fraud or to enforce or protect the rights and properties of eTranzact</li>
              <li class="text-gray-400 text-sm">(iv) Protect the personal safety of eTranzact employees and third parties on eTranzact property.</li>
            </ul>
          </li>
          <li class="mt-8 pt-4" id="prevent">
            <p class="text-blue-500 text-sm font-bold">How do we prevent harm to your personal Data?</p>
            <p class=" mt-6 text-gray-400 text-sm leading-7">We build security into our services to protect your information. All eTranzact products are built with strong security features based on industry and regulatory requirements which will continuously protect your information.</p>
            <p class=" mt-6 text-gray-400 text-sm leading-7">The insights we gain from continuous monitoring of our platforms help us to detect and block security threats from ever reaching you.  Some of the measures we have in place include:</p>
            <ul class="mt-4 list-disc">
              <li class="text-gray-400 text-sm mb-2">1. Use encryption to keep your data private while in transit as required by PCI DSS</li>
              <li class="text-gray-400 text-sm mb-2">2. Safe Browsing by use of secure web protocol, Security Checkup, and 2 Step Verification to help you protect your account</li>
              <li class="text-gray-400 text-sm mb-2">3. Monitoring and periodic reviews including physical security measures, to prevent unauthorized access to our systems</li>
            </ul>
          </li>
          <li class="mt-8 pt-4" id="changes">
            <p class="text-blue-500 text-sm font-bold">How will we notify you of changes to this policy?</p>
            <p class=" mt-6 text-gray-400 text-sm leading-7">If there is any changes to policy, we shall notify you before we make final so that you can have the opportunity to review the revised policy before you choose to continue using our Products.
            </p>
          </li>
          <li class="mt-8 pt-4" id="protection">
            <p class="text-blue-500 text-sm font-bold">Data Protection Rights</p>
            <p class=" mt-6 text-gray-400 text-sm leading-7">eTranzact clients or partners have data protection rights and are entitled to the following</p>
            <p class=" mt-4 text-gray-400 text-sm leading-7">eTranzact clients or partners  are entitled to request copies of their personal data. Charges for this service may apply if it will require significant resources to achieve.</p>
            <p class=" mt-4 text-gray-400 text-sm leading-7">eTranzact clients or partners  have the right to request that we delete their personal data, within specific terms such terms are not limited  to regulatory requirements, law enforcement agencies, Legal entities or where such action may result in system or services failure.</p>
            <p class=" mt-4 text-gray-400 text-sm leading-7">eTranzact clients or partners  have the right to request that we update any information in our possession that they believe and prove to have been captured incorrectly and update such information should be updated as appropriate.</p>
            <p class=" mt-4 text-gray-400 text-sm leading-7">eTranzact clients or partners  are at liberty to request that we limit the processing of their personal data, within specific terms such terms are not limited  to regulatory requirements, law enforcement agencies, Legal entities or where such action may result in system or services failure.</p>
            <p class=" mt-4 text-gray-400 text-sm leading-7">eTranzact clients or partners are at will to object to eTranzact reusing their personal data, within specific terms such terms are not limited  to regulatory requirements, law enforcement agencies, Legal entities or where such action may result in system or services failure</p>
            <p class=" mt-4 text-gray-400 text-sm leading-7">Should you have any questions about our GDPR/NDPR compliance program, please contact our Data Protection Office via:</p>
            <p class=" mt-4 text-gray-400 text-sm leading-7">cic@etranzact.com</p>
            <p class=" mt-2 text-gray-400 text-sm leading-7">OR visit our head office:</p>
            <p class=" mt-2 text-gray-400 text-sm leading-7">27/29 Adeyomo Alakija</p>
            <p class=" mt-2 text-gray-400 text-sm leading-7">Victoria Island</p>
            <p class=" mt-2 text-gray-400 text-sm leading-7">Lagos, Nigeria</p>
          </li>
          <!-- <li class="mt-8" id="exclusions">
            <p class="text-blue-500 text-sm font-bold">Advertising of Packaged Services</p>
            <p class=" mt-6 text-gray-400 text-sm leading-7">Where eTranzact represents in advertising materials that a service is provided as part of a package, eTranzact shall ensure it is able to supply all components of the service package. In the event that eTranzact is or may be unable to supply any component of the package, appropriate information about this limitation shall be included in the advertising materials. Where advertising materials indicate the price of a component of a service package, eTranzact shall include in the advertising materials a statement of the minimum total charge for the package, and indicate any Conditions that may apply to obtain the component at the stated price.
            </p>
          </li>
          <li class="mt-8" id="other">
            <p class="text-blue-500 text-sm font-bold">Complaint Processes </p>
            <p class=" mt-6 text-gray-400 text-sm leading-7">eTranzact operates a customer service desk which is reachable during working hours from 8:00am to 5:00pm and outside working hours via e-mail. All consumers can contact the help desk via telephone; OJ -270J J62 email: info-ng@etranzact.com. Before you contact our support desk please make sure that you have details of the transaction initiated, your mobile number,) and summary of the complaint. This will enable us process and resolve your complaints quickly.
            </p>
          </li>
          <li class="mt-8" id="modification">
            <p class="text-blue-500 text-sm font-bold">Further Recourse</p>
            <p class=" mt-6 text-gray-400 text-sm leading-7">In the event that the complaining customer remains dissatisfied with the outcome/resolution of the complaint, has the right to refer the complaint to Nigerian Communication Commission (NCC).
            </p>
          </li>
          <li class="mt-8" id="user">
            <p class="text-blue-500 text-sm font-bold">Data Collection and Analysis of Complaints and Outcome </p>
            <p class=" mt-6 text-gray-400 text-sm leading-7">An appropriate recording system for complaints and their outcome/resolution shall be set up and such system shall have all complaints and resolution stored in a discernible manner for easy identification.
            </p>
          </li>
          <li class="mt-8" id="third">
            <p class="text-blue-500 text-sm font-bold">Retention of Records </p>
            <p class=" mt-6 text-gray-400 text-sm leading-7">Any information collected and recorded as part of complaint handling processes shall be retained for at least twelve (1 2) months following the resolution of complaints or as directed by NCC from time to time.
            </p>
          </li>
          <li class="mt-8" id="indem">
            <p class="text-blue-500 text-sm font-bold">Opt-In and Opt-Out</p>
            <p class=" mt-6 text-gray-400 text-sm leading-7">Upon request for any service, eTranzact shall provide the consumer with Opt-in and Opt-out options in clear, simple and understandable terms eTranzact shall provide the consumer with access to a HELP function to obtain information on services they are at the time of request, subscribed to and how to opt out in clear plain English.
            </p>
          </li>
          <li class="mt-8" id="eco">
            <p class="text-blue-500 text-sm font-bold">Billing Information </p>
            <p class=" mt-6 text-gray-400 text-sm leading-7">eTranzact shall ensure that, at a minimum, the following information is included in any billing or charging notifications issued by it or on its behalf: <br>
            (a) The name of the service for which the consumer has been billed <br>
            (b) The type of the service for which the consumer has been billed and the service delivery medium <br>
            (c) The period over which the service associated with the charge will be provided <br>
            (d) The total amount billed or charged to the consumer's prepaid account 

            </p>
          </li>
          <li class="mt-8" id="general">
            <p class="text-blue-500 text-sm font-bold">Itemization of Charges</p>
            <p class=" mt-6 text-gray-400 text-sm leading-7">eTranzact shall ensure that each consumer has access to itemised details to all charges pertaining to subscribers on that mobile network and eTranzact shall ensure that all such itemized details are available for 1 2 months after the billing/charges effect has occurred.
            </p>
          </li>
          <li class="mt-8" id="mod">
            <p class="text-blue-500 text-sm font-bold">Timing for Issuance of Bill </p>
            <p class=" mt-6 text-gray-400 text-sm leading-7">eTranzact shall bill Consumers at the point of activation and shall equally ensure that in instances where a service for which a consumer has been billed cannot be delivered, the consumer will be subsequently offered the service at no extra cost for a period of time equal to the period over which the service should have been delivered but was not. Where the circumstances will not permit the service to be delivered (due to circumstances beyond the reasonable control of eTranzact, such as an event of force majeure or a technical system failure at the mobile network resulting in service interruption), eTranzact shall liaise with the mobile network operator to establish a suitable resolution path that will ensure that consumers do not lose any value and are appropriately refunded and compensated.
            </p>
          </li>
          <li class="mt-8" id="pcon">
            <p class="text-blue-500 text-sm font-bold">Payment Confirmation  </p>
            <p class=" mt-6 text-gray-400 text-sm leading-7">eTranzact shall ensure that Consumers are able to verify their bill payment by acknowledgment of payment on the next bill issued, with such appropriate and accessible methods as may be made available by eTranzact. 
            </p>
          </li>
          <li class="mt-8" id="freq">
            <p class="text-blue-500 text-sm font-bold">Billing Frequency  </p>
            <p class=" mt-6 text-gray-400 text-sm leading-7">eTranzact shall provide Consumers with advance written notification of any proposed changes in billing before any such changes are implemented via any channel over which eTranzact services are offered. Consumers shall be informed in all such notifications of how to opt out of the service to avoid experiencing the proposed changes in billing.
            </p>
          </li> -->
        </ul>
      </div>
    </div>
    <font-awesome-icon icon="angle-down" class="ml-8 cursor-pointer" @click="scrollDown"/>
  </div>
</template>

<script>
export default {
  data(){
    return {
      selected: 'introduction',
      selectedClass: 'text-blue-900 font-bold',
    }
  },
  methods: {
    scrollDown(){
      this.$refs.sidelist.scrollTop += 100
    }
  }
}
</script>

<style scoped>
ul.sidelist{
  min-width: 25%;
  max-height: 400px;
  overflow-y: auto;
}
ul.sidelist li {
  color: #062648;
}
.details{
  max-height: 450px;
  overflow-y: auto;
  scroll-behavior: smooth;
}
.details::-webkit-scrollbar-track, .sidelist::-webkit-scrollbar-track
{
	-webkit-box-shadow: inset 0 0 2px rgba(0,0,0,0.3);
	background-color: #F5F5F5;
}
.details::-webkit-scrollbar, .sidelist::-webkit-scrollbar
{
  width: 0px;
	background-color: #F5F5F5;
}

</style>